import { useCallback } from 'react';
import debounce from 'lodash/debounce';
import {debounceInterval} from "../utils/globals";
import {patchWidget} from "../utils/api";

export const usePlotAndValidateFields = ({
  id,
  tool,
  handleDataUpdating,
  handleErrorSetting,
  pushApiCount,
}) => {
  return useCallback(
    debounce((widget, params) => {
      pushApiCount();
      patchWidget(id, tool, widget, params)
        .then(response => {
          handleDataUpdating(
            response.data.tool,
            response.data.modifications,
            response.data.warnings
          );
        })
        .catch(error => {
          handleErrorSetting(error);
        });
    }, debounceInterval),
    [
      id,
      tool,
      handleDataUpdating,
      handleErrorSetting,
      pushApiCount,
    ]
  );
};
